import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import { CourseAnnualDetailAPI } from "../../../../api/course-annual-detail/course-annual-detail.api";
import FilterSelect from "../../../../components/select/filterSelect";
import { MenuItem } from "@mui/material";
import { routeName } from "../../../../routes/routeName";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { degreeApi } from "../../../../api/degree/degree.api";
import { advisorEstimateScoreApi } from "../../../../api/advisor-estimate-score/advisor-estimate.api";
import { ButtonOutlined } from "../../../../components/button/ButtonCustoms";

type Props = {};

const TeacherEvaluationScoresDetail: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_year = queryParams.get("year");
  const prop_term = queryParams.get("term");

  const [data, setData] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState([]);
  const [dataDegree, setDataDegree] = useState([]);
  const [advisorType, setAdvisorType] = useState<any[]>([{ id_advisor_type: 'LEAD_INSTRUCTOR', advisor_type_name: 'อาจารย์ผู้สอนหลัก' }, { id_advisor_type: 'CO_INSTRUCTOR', advisor_type_name: 'อาจารย์ผู้สอนร่วม' }, { id_advisor_type: 'MAIN_ADVISOR', advisor_type_name: 'อาจารย์ที่ปรึกษาหลัก' }, { id_advisor_type: 'CO_ADVISOR', advisor_type_name: 'อาจารย์ที่ปรึกษาร่วม' }])

  const [search, setSearch] = useState<string>("");
  const [selectedFacultyId, setSelectedFacultyId] = useState<string>("");
  const [selectedDegreeId, setSelectedDegreeId] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const fetchGetFaculty = async () => {
    let query: any = {
      page: 1,
      limit: 1000,
    };

    const res = await facultyApi.getFaculty();
    const data = res.data;
    if (data.status < 300 && data.data && data.data.length > 0) {
      setDataFaculty(data.data);
    } else {
      setDataFaculty([]);
    }
  };

  const fetchGetDegree = async () => {
    let query: any = {
      page: 1,
      limit: 1000,
    };

    const res = await degreeApi.getDegree();
    const data = res.data;
    if (data.status < 300 && data.data && data.data.length > 0) {
      setDataDegree(data.data);
    } else {
      setDataDegree([]);
    }
  };

  useEffect(() => {
    fetchGetFaculty();
    fetchGetDegree();
  }, []);

  const getData = async (id: number) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
      id_faculty: selectedFacultyId ?? "",
      id_degree: selectedDegreeId ?? "",
    };

    const res =
      await advisorEstimateScoreApi.getCourseAnnualEmployeeByIdCourseOfStudy(
        +id,
        query
      );
    const data = res.data;
    if (data.status < 300) {
      setData(res.data?.data?.items ?? []);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const headCells = [
    {
      id: "period",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อ - นามสกุล",
    },
    {
      id: "period",
      width: 125,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "เลขประจำตัวเจ้าหน้าที่",
    },
    {
      id: "level",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ตำแหน่งงาน",
    },
    {
      id: "department",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "หน่วยงาน",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  // study_day 0 === อาทิด
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_course_of_study,
      year,
      term,
      id_employee,
      full_name,
      buddhist_name,
      employee_no,
      position,
      department,
      id_course_annual,
    } = objData;

    const objRenderData = {
      key: id_course_of_study,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: full_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: employee_no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: advisorType?.find((x:any) => x?.id_advisor_type === position)?.advisor_type_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: department ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  navigate(
                    routeName.advisor.TeacherEvaluationScores +
                    `/${id_course_of_study}/course-detail/${id_employee}/employee?employee_no=${employee_no}&employee_name=${full_name}&year=${prop_year}&term=${prop_term}`
                  );
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    if (id) {
      getData(+id);
    }
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    selectedFacultyId,
    selectedDegreeId,
    id,
  ]);

  return (
    <div>
      <ContentHeading
        title={`รายวิชาที่สอน ปีการศึกษา ${prop_year} ภาคเรียนที่  ${prop_term}`}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <ButtonOutlined
          onClick={() => navigate(-1)}
          mode="del"
          buttonName="ย้อนกลับ"
        />
      </div>
    </div>
  );
};

export default TeacherEvaluationScoresDetail;
